// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2SHcz","buttons":"PendingPaymentAlert_buttons__3hLcq"};